import get from 'lodash/get';
import type { OptionFilterDef, OptionFilters } from './types';
import { isOptionFilterList } from './checks';

const eqFilter = ([, path, value]: OptionFilters['xf_eq']) => {
  return (opt: any) => get(opt, path) === value;
};

const notEqFilter = ([, path, value]: OptionFilters['xf_not_eq']) => {
  return (opt: any) => get(opt, path) !== value;
};

const boolFilter = ([, path]: OptionFilters['xf_bool']) => {
  return (opt: any) => Boolean(get(opt, path));
};

const invertFilter = ([, path]: OptionFilters['xf_invert']) => {
  return (opt: any) => !get(opt, path);
};

const orFilter = ([, ...filters]: OptionFilters['xf_or']) => {
  return (opt: any): boolean => {
    return filters.some((x: OptionFilterDef) => Boolean(runFilter(x, opt)));
  };
};

const andFilter = ([, ...filters]: OptionFilters['xf_and']) => {
  return (opt: any): boolean => {
    return filters.every((x: OptionFilterDef) => Boolean(runFilter(x, opt)));
  };
};

const someFilter = ([, array, path]: OptionFilters['xf_some']) => {
  return (opt: any): boolean => {
    const value = get(opt, path);
    return array.includes(value);
  };
};

const runFilter = (x: OptionFilterDef, option: any) => {
  switch (x[0]) {
    case 'xf_and':
      return andFilter(x)(option);
    case 'xf_or':
      return orFilter(x)(option);
    case 'xf_bool':
      return boolFilter(x)(option);
    case 'xf_invert':
      return invertFilter(x)(option);
    case 'xf_eq':
      return eqFilter(x)(option);
    case 'xf_not_eq':
      return notEqFilter(x)(option);
    case 'xf_some':
      return someFilter(x)(option);
    default:
      return true;
  }
};

export const optionFilter = (x: OptionFilterDef | OptionFilterDef[]) => {
  if (isOptionFilterList(x)) {
    return (opt: any) => x.map((f) => runFilter(f, opt)).every(Boolean);
  }

  return (opt: any) => runFilter(x, opt);
};
